module.exports = __webpack_public_path__ + "img/reset.153634c6.svg";